var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "accordion-content__client" },
    [
      _vm.get(_vm.paymentInfo, "payoneer_accounts.length")
        ? _c("settings-payment-payoneer-accounts", {
            attrs: { selectable: _vm.selectable }
          })
        : _vm._e(),
      !_vm.get(_vm.paymentInfo, "payoneer_accounts.length")
        ? _c(
            "vs-layout",
            {
              staticClass: "payoneer",
              attrs: {
                "wrap-xs": "wrap-xs",
                "vert-align-center-xs": "vert-align-center-xs"
              }
            },
            [
              _c(
                "vs-layout",
                {
                  attrs: {
                    "horz-align-center-xs": "horz-align-center-xs",
                    "horz-align-right-sm": "horz-align-right-sm",
                    sm: "4",
                    "margin-top": "2"
                  }
                },
                [
                  _c("div", {
                    staticClass: "payoneer__img-connect",
                    style: _vm.payoneerConnectImage
                  })
                ]
              ),
              _c(
                "vs-layout",
                {
                  attrs: {
                    "horz-align-center-xs": "horz-align-center-xs",
                    "horz-align-left-sm": "horz-align-left-sm",
                    sm: "7",
                    "margin-top": "2",
                    "offset-sm": "1"
                  }
                },
                [
                  _c("vs-button", {
                    staticClass: "payoneer--smaller-text",
                    attrs: {
                      large: "large",
                      text: "Connect Payoneer<sup>®</sup> Account",
                      processing: _vm.processing,
                      disabled: _vm.processing,
                      "single-line-button": "single-line-button"
                    },
                    on: { click: _vm.register }
                  })
                ],
                1
              ),
              _c("vs-layout", { attrs: { "margin-top": "2" } }, [
                _c("hr", { staticClass: "payoneer__hr" })
              ]),
              _c(
                "vs-layout",
                {
                  attrs: {
                    "horz-align-center-xs": "horz-align-center-xs",
                    sm: "4",
                    lg: "3",
                    "margin-top": "2"
                  }
                },
                [
                  _c("div", {
                    staticClass: "payoneer__img",
                    style: _vm.payoneerImage
                  })
                ]
              ),
              _c(
                "vs-layout",
                {
                  attrs: {
                    "col-xs": "col-xs",
                    "vert-align-top-xs": "vert-align-top-xs",
                    sm: "8",
                    lg: "9",
                    "margin-top": "2"
                  }
                },
                [
                  _c("h6", { staticClass: "payoneer__text" }, [
                    _vm._v(
                      "Payoneer provides payment solutions for sellers around the world. Receive payments in over 200 countries, 90 currencies and easily withdraw funds to your local bank account."
                    )
                  ])
                ]
              )
            ],
            1
          )
        : !_vm.modal
        ? _c("vs-button", {
            attrs: {
              large: "large",
              text: "Connect Another Payoneer<sup>®</sup> Account",
              processing: _vm.processing,
              disabled: _vm.processing
            },
            on: { click: _vm.register }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }